export default "<grange-auth>\n</grange-auth>\n"